module.exports = __webpack_public_path__ + "img/result-oman-02.d82f1701.svg";